import React from 'react';
import '../../../assets/css/common/video/discuss.css';
import config from '../../../assets/js/conf/config.js';
import {request,request2} from '../../../assets/js/libs/request.js';
import {connect} from 'react-redux';
import {lazyImg} from '../../../assets/js/utils/util.js';
import { Toast } from 'antd-mobile';
import $ from 'jquery';

import 'emoji-mart/css/emoji-mart.css';
import { Picker } from 'emoji-mart';
import { Emoji } from 'emoji-mart'

class VideoDiscuss extends React.Component {
	constructor(props){
		super(props);
		//console.log(props, props.state.outlineId.Id,localStorage['outlineDetails'])
		this.state = {
			EmojiFlag: false,
			questionFlag: false,
			Screen: false,
			outlineId: props.state.outlineId.Id?props.state.outlineId.Id:'',
			startTime: '',
			uId: '',
			IputVal: '',
			MessageArr: [],
			phone: localStorage['LoginData'] != undefined?JSON.parse(localStorage['LoginData']).phone:'',
			emjString: ''
		}
		this.Screen = true;
		this.timer2 = null;
		
		this.emj = ['recent',"people","nature"];
		this.emjSize = 18;
		
	}
	componentDidMount() {
		let that = this;
		
      	if(this.state.outlineId){
      		this.ListenScroll2();
			that.getMessage();
			
			// this.timer2 = setInterval(function(){
			// 	that.getMessage();
			// }, 1500)
		}
	}
	ListenScroll2(){
		let that = this;
		var bScroll=true;
		let otherCScrol = true;
		this.refs['other-content2'].addEventListener("scroll", function(e){
			var ev = e || window.event;
			ev.stopPropagation();
			
			
			if(!bScroll){
	            return;
	        }
			clearInterval(that.timer2);
			otherCScrol = false;
	        bScroll=false;
			
			setTimeout(function(){
                var scrollTop = e.target.scrollTop;    //滚动条距离顶部的高度
				var scrollHeight = parseInt( that.getHeight( document.querySelector(".ul2") ,'height'));   //当前页面的总高度
				var clientHeight =  parseInt( that.getHeight( document.querySelector(".other-content2") ,'height'));    //当前可视的页面高度
				
				//console.log(scrollTop + clientHeight , scrollHeight)
	
				if(scrollTop + clientHeight >= scrollHeight){   //距离顶部+当前高度 >=文档总高度 即代表滑动到底部 
				    //滚动条到达底部
				    //console.log(3) 
				    that.timer2 = setInterval(function(){
						that.getMessage();
					}, 5000);
				}else if(scrollTop<=0){
					//滚动条到达顶部
					//console.log(4)
					otherCScrol = true;
					
					// let data = {
					//   "outlineId": that.state.outlineId,
					//   "count": 10,
					//   "startTime": that.state.startTime,
					//   "order": "desc",
					//   'uId': that.state.uId
					// }
					
					// request(config.baseUrl+'api/Study/M01', "post", data).then(res=>{
					// 	if(res.code === 0) {
					// 		if(res.data.length > 0) {
					// 			//res.data.reverse();
					// 			let MessageArr = that.state.MessageArr;
								
					// 			res.data.forEach(item=>{
					// 				let resultArr = item.Msg_Context.split(':');
     //        						item.ContextArr = resultArr;
			  //           			MessageArr.unshift(item)
			  //           		})
			  //           		that.setState({
				 //            		MessageArr: MessageArr,
				 //            		startTime: res.data[res.data.length-1].Msg_CrtTime,
	    //         					uId: res.data[res.data.length-1].UID
				 //            	},()=>{
				 //            		lazyImg();
				 //            	})
					// 		}
					// 	}
					// })
				}
                bScroll=true;
            },200);
		},false);
		
		
		//滑动加载
		var currntY = 0,
			lastY = 0,
			direction = 0;
		
		document.getElementById("ul2").addEventListener('touchstart', function(e) {
			var ev = e || window.event;
			ev.stopPropagation();
			if(!otherCScrol){
				return
			}
			var ev = e || window.event;
			lastY = parseInt( ev.targetTouches[0].clientY );
			//console.log("lastY",lastY)
		}, false);
		       
		document.getElementById("ul2").addEventListener('touchmove', function(e) {
			var ev = e || window.event;
			ev.stopPropagation();
			if(!otherCScrol){
				return
			}
			var ev = e || window.event;
			currntY = parseInt( ev.changedTouches[0].clientY );
			//console.log(otherCScrol,"currntY",currntY)
			direction =  currntY - lastY;
		    if (direction > 0) {
		        //console.log("下")
		        
		        that.setState({
		        	scHei: direction
		        })
		        if(!bScroll){
		            return;
		       	}
		        bScroll=false;
		        //滚动条到达顶部
				setTimeout(function(){
					let data = {
					  "merchandiseId": that.state.outlineId,
					  "count": 10,
					  "startTime": that.state.startTime,
					  "order": "desc",
					  'uId': that.state.uId
					}
					
					request(config.baseUrl+'api/Study/M01', "post", data).then(res=>{
						if(res.code === 0) {
							if(res.data.length > 0) {
								//res.data.reverse();
								let MessageArr = that.state.MessageArr;
								
								let time= res.data[0].Msg_CrtTime.slice(0, 19).replace(/-/g, '/');
			            		for(let i=0;i<res.data.length;i++){
			            			let NextTime = i<= res.data.length-2 ? res.data[i+1].Msg_CrtTime.slice(0, 19).replace(/-/g, '/'):0;
			            			if(i<= res.data.length-2 && (new Date(time) - new Date(NextTime) > 60000)){
			            				time = NextTime;
			            				res.data[i].timeFlag = true;
			            			}else{
			            				res.data[i].timeFlag = false;
			            			}
			            			MessageArr.unshift(res.data[i])
			            		}
			            		
//								res.data.forEach(item=>{
//									let resultArr = item.Msg_Context.split(':');
//									item.ContextArr = resultArr;
//					    			MessageArr.unshift(item)
//					    		})
					    		that.setState({
					        		MessageArr: MessageArr,
					        		startTime: res.data[res.data.length-1].Msg_CrtTime,
									uId: res.data[res.data.length-1].UID
					        	},()=>{
					        		lazyImg();
					        	})
							}
						}
					})
					bScroll=true;
				}, 200);
			} else {
			    //console.log("上")
			}
		}, false);
		document.getElementById("ul2").addEventListener('touchend', function(e) {
			var ev = e || window.event;
			ev.stopPropagation();
			if(!otherCScrol){
				return
			}
			that.setState({
		    	scHei: 0
		    })
			bScroll=true;
		}, false);
	}
	getHeight( obj, style ){
	　　return window.getComputedStyle(obj).getPropertyValue(style);
	}
	componentWillReceiveProps (newProps) {
		//console.log(newProps)
		//在组件完成更新后立即调用。在初始化时不会被调用。
        let that = this;
        if(newProps.discussStyle.display == "none"){
        	clearInterval(this.timer2);
        }
//		else if(newProps.discussStyle.display == "block"){
////        	this.timer2 = setInterval(function(){
////				that.getMessage();
////			}, 1500)
////        	if(that.state.outlineId){
////				that.getMessage();
////			}
//      }
//      this.setState({
//      	outlineId: newProps.state.outlineId.Id
//      })
  	}
	getMessage(startTime, uId){
		//console.log(222)
		//获取信息
		let data = {
			  "merchandiseId": this.state.outlineId,
			  "count": 10,
			  "startTime": startTime,
			  "order": "desc",
			  'uId': uId
			}
		//console.log(data)
		request2(config.baseUrl+'api/Study/M01', "post", data).then(res=>{
			//console.log(res.data)
            if(res.code == 0){
            	if(res.data.length>0){
            		let time= res.data[0].Msg_CrtTime.slice(0, 19).replace(/-/g, '/');
            		for(let i=0;i<res.data.length;i++){
            			let NextTime = i<= res.data.length-2 ? res.data[i+1].Msg_CrtTime.slice(0, 19).replace(/-/g, '/'):0;
            			if(i<= res.data.length-2 && (new Date(time) - new Date(NextTime) > 60000)){
            				time = NextTime;
            				res.data[i].timeFlag = true;
            			}else{
            				res.data[i].timeFlag = false;
            			}
            		}
            		
            		//颠倒数组中元素的顺序
            		res.data.reverse()
            		
            		this.setState({
	            		MessageArr: res.data,
	            		startTime: res.data[res.data.length-1].Msg_CrtTime,
	            		uId: res.data[res.data.length-1].UID
	            	},()=>{
	            		lazyImg();
	            	})
            	}
            }
            //console.log(this.state.MessageArr)
        });
	}
	subMessage(){
		this.setState({
			EmojiFlag: false
		})
		let that = this;
		//发送信息
		let data = {
			  "messageContent": this.state.IputVal,
			  "merchandiseId": this.state.outlineId,
			  "isQuestion": this.state.questionFlag?1:0
			}
		if(this.state.IputVal == ""){
			return
		}
		request(config.baseUrl+'api/Study/M02', "post", data).then(res=>{
            if(res.code == 0){
            	//console.log(res)
            	that.getMessage();
            	this.setState({
            		IputVal: ''
            	})
            }
        });
	}
	componentWillUnmount(){
    	//界面离开的时候
		this.Screen = false;
		this.refs['other-content2'].removeEventListener("scroll", this.isScren.bind(this));
		this.setState = (state, callback)=>{
			return;
		}
		clearInterval(this.timer2);
	}
	isScren(){
    	if(this.Screen){
    		let isScreen = this.refs['other-content2'].scrollTop;
	    	if(isScreen>=50){
	    		this.setState({
	    			Screen : true
	    		});
	    	}else{
	    		this.setState({
	    			Screen : false
	    		});
	    	}
    	}
    }
	questionFlagClick(){
		let questionFlag = this.state.questionFlag;
		this.setState({
			questionFlag: !questionFlag
		})
	}
	preventDefault(e){
		e.preventDefault();
		e.stopPropagation();
	}
	EmojiFlag(){
		let EmojiFlag = this.state.EmojiFlag;
		this.setState({
			EmojiFlag: !EmojiFlag
		})
	}

	render() {
		return(
			<div style={this.props.discussStyle} className={"discuss-bg"} onClick={this.props.display.bind(this,{display: 'none'})}>
			
				<div className={'other discuss'} ref='other' onClick={this.preventDefault.bind(this)}>
					<div className={'discuss-title'}>
						<div className={'title1'}>
							<span className={'sp1'}>讨论区 </span>
							<span className={'sp2'} onClick={this.props.display.bind(this,{display: 'none'})}>×</span>
						</div>
						<div className={this.state.Screen?'title2 scroll':'title2'}>{this.state.MessageArr.length>0 && this.state.MessageArr[0].Msg_CrtTime.slice(5, 19)}</div>
					</div>
					<div className={'other-content other-content2'} ref='other-content2'>
						<div className={this.state.scHei>0?'shauxin':'hide'}>
							下拉刷新
						</div>
						<ul id='ul2' className='ul2'>
							{
								this.state.MessageArr.length>0 &&
								this.state.MessageArr.map((item, index)=>{
									if(this.state.phone !== item.Ac_AccName){
										return(
											<li key={index}>
												<p className={item.timeFlag?'liTime':'hide'}>{item.Msg_CrtTime.slice(0, 19)}</p>
												<div className={'liName'}>
													<div className={'li-img'}>
														<img src={item.Ac_Photo?item.Ac_Photo:require('../../../assets/images/common/my1.png')} alt={item.Ac_Name} />
													</div>
													<div className={'li-name'}>
														<span className={'name'}>{item.Ac_Name}</span>
														<div className={'li-cont'} style={{paddingLeft: item.Msg_IsQuestion?'0.7rem':''}}>
															<div className={item.Msg_IsQuestion?'':'hide'}>
																<span className={'wen'}>问</span>
															</div>
															<div>
																{item.Msg_Context}
															</div>
														</div>
													</div>
												</div>
											</li>
										)
									}else{
										return (
											<li className={'myQus'} key={index}>
												<p className={item.timeFlag?'liTime':'hide'}>{item.Msg_CrtTime.slice(0, 19)}</p>
												<div className={'liName'}>
													<div className={'li-name'}>
														{
															//<span className={'guanli'}>管理员</span>
														}
														<span className={'name'}>{item.Ac_Name}</span>
														<div className={'li-cont'} style={{paddingLeft: item.Msg_IsQuestion?'0.7rem':''}}>
															<div className={item.Msg_IsQuestion?'':'hide'}>
																<span className={'wen'}>问</span>
															</div>
															<div>
																{item.Msg_Context}
															</div>
														</div>
													</div>
													<div className={'li-img'}>
														<img src={item.Ac_Photo?item.Ac_Photo:require('../../../assets/images/common/my1.png')} alt={item.Ac_Name} />
													</div>
												</div>
											</li>
										)
									}
								})
							}
						</ul>
					</div>
					<div className={'other-foot'}>
						{
//							<div className={'other-icon icon1'} onClick={this.EmojiFlag.bind(this)}>赏</div>
						}
						<div className={'other-iupt'}>
							<input type="sunmit" placeholder="说点什么吧！" value={this.state.IputVal} onChange={(e)=>{this.setState({IputVal: e.target.value})}} />
							<div className={this.state.questionFlag?'other-spa1 active':'other-spa1'} onClick={this.questionFlagClick.bind(this)}>
								<span className={'TiWenFlag'}></span><span>提问</span>
							</div>
						</div>
						<div className={'other-icon'} onClick={this.subMessage.bind(this)}>
							发送
						</div>
					</div>
					{
						//表情
//						<div className={this.state.EmojiFlag?'Emoji':'hide'}>
//							<Picker set='apple' onClick={(emoji, event) => {
//									let IputVal = this.state.IputVal;
//									this.setState({
//										IputVal: IputVal + emoji.colons
//									})
//								}}
//								emoji='heart_eyes' 
//								include={this.emj}
//							/>
//						</div>
					}
					
			    </div>
			</div>
		);
	}
}
export default connect((state)=>{
	return {
		state: state
	}
})(VideoDiscuss)
